if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        try {
          // ── STEP 1: Add main product ──────────────────────────────
          const mainRes = await fetch(`${routes.cart_add_url}`, config);
          const response = await mainRes.json();

          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);
            this.error = true;
            return;
          }

          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          // ── STEP 2: Collect checked also-bought items ─────────────
          const mainVariantId = String(formData.get('id')).trim();
          const checked = document.querySelectorAll('.cab-checkbox:checked');

          const seen = new Set();
          const bundleItems = [];

          checked.forEach((checkbox) => {
            const id = String(checkbox.value).trim();
            if (!id || id === 'null' || id === 'undefined') return;
            if (id === mainVariantId) return;
            if (seen.has(id)) return;
            seen.add(id);
            bundleItems.push({ id: Number(id), quantity: 1 });
          });

          console.log('MAIN VARIANT:', mainVariantId);
          console.log('BUNDLE ITEMS:', bundleItems);

          // ── STEP 3: Add bundle items ──────────────────────────────
          if (bundleItems.length > 0) {
            try {
              const bundleRes = await fetch(`${routes.cart_add_url}`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: 'application/json',
                  'X-Requested-With': 'XMLHttpRequest',
                },
                body: JSON.stringify({ items: bundleItems }),
              });
              const bundleData = await bundleRes.json();
              if (bundleData.status) {
                console.warn('Bundle add warning:', bundleData.description);
              }
            } catch (bundleErr) {
              console.error('Bundle items add failed:', bundleErr);
            }

            await new Promise((r) => setTimeout(r, 150));
          }

          this.error = false;

          // ── STEP 4: Update cart icon ──────────────────────────────
          try {
            const sectionsRes = await fetch('/?sections=cart-icon-bubble');
            const sections = await sectionsRes.json();
            const icon = document.querySelector('#cart-icon-bubble');

            if (icon && sections['cart-icon-bubble']) {
              const temp = document.createElement('div');
              temp.innerHTML = sections['cart-icon-bubble'];
              const newIcon = temp.querySelector('#cart-icon-bubble');
              if (newIcon) {
                icon.innerHTML = newIcon.innerHTML;
              }
            }
          } catch (iconErr) {
            console.error('Cart icon update failed:', iconErr);
          }

          // ── STEP 5: Fetch fresh cart state ────────────────────────
          let cartResponse = response;
          try {
            const freshCartRes = await fetch(`${routes.cart_url}`, {
              headers: { Accept: 'application/json' },
            });
            cartResponse = await freshCartRes.json();
          } catch (cartErr) {
            console.warn('Fresh cart fetch failed:', cartErr);
          }

          // ── STEP 6: Publish cart update ───────────────────────────
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: mainVariantId,
            cartData: cartResponse,
          });

          // ── STEP 7: Render notification with fresh sections ───────
          const renderWithFreshSections = async () => {
            try {
              const sectionIds = this.cart
                .getSectionsToRender()
                .map((s) => s.id)
                .join(',');
              const freshRes = await fetch(`/?sections=${sectionIds}`);
              const freshSections = await freshRes.json();
              response.sections = freshSections;
            } catch (e) {
              console.warn('Fresh sections fetch failed:', e);
            }

            this.cart.renderContents(response);
          };

          const quickAddModal = this.closest('quick-add-modal');

          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => renderWithFreshSections(), 50);
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            setTimeout(() => renderWithFreshSections(), 50);
          }

        } catch (e) {
          console.error('Add to cart error:', e);
        } finally {
          this.submitButton.classList.remove('loading');

          if (this.cart && this.cart.classList.contains('is-empty')) {
            this.cart.classList.remove('is-empty');
          }

          if (!this.error) {
            this.submitButton.removeAttribute('aria-disabled');
          }

          this.querySelector('.loading__spinner').classList.add('hidden');
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
